import React, {useState, useEffect } from 'react';

const LoanCalculator = ({ dynamicPrice }) => {
    const noInput = 'Enter a price';

    const [price, setPrice] = useState(dynamicPrice || '');
    const [downPayment, setDownPayment] = useState(0);
    const [apr, setApr] = useState(6);
    const [loanTerm, setLoanTerm] = useState(36);
    const [monthlyPayment, setMonthlyPayment] = useState(0);

    useEffect(() => {
        if (typeof dynamicPrice === 'number' && dynamicPrice > 0) {
            setPrice(dynamicPrice);
        }
    }, [dynamicPrice]);

    useEffect(() => {
        calculateLoan();
    }, [price, downPayment, apr, loanTerm]);

    const formatNumberWithCommas = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const calculateLoan = () => {
        const loanAmount = Math.max(price - (downPayment || 0), 0);
        const monthlyInterestRate = (apr / 100) / 12;
        const numberOfPayments = loanTerm;

        if (loanAmount === 0 && downPayment === 0) {
            setMonthlyPayment(0);
            return;
        }

        let monthlyPaymentValue;

        if (monthlyInterestRate === 0) {
            monthlyPaymentValue = loanAmount / numberOfPayments;
        } else {
            monthlyPaymentValue = (loanAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments));
        }

        if (!isNaN(monthlyPaymentValue) && price !== '') {
            setMonthlyPayment(formatNumberWithCommas(Math.round(monthlyPaymentValue)));
        } else {
            setMonthlyPayment(noInput);
        }
    }

    return (
        <div id="loan-form">
            <h3 className="center-text">Calculate your monthly payment.</h3>
            <div className="input-wrapper">
                <label htmlFor="price">Price:</label>
                <input type="number" id="price" value={price} onChange={(e) => setPrice(Math.round(parseFloat(e.target.value)))} step="1" />
            </div>
            <div class="input-wrapper">
                <label htmlFor="down-payment">Down Payment:</label>
                <input type="number" id="down-payment" value={downPayment} onChange={(e) => setDownPayment(Math.round(parseFloat(e.target.value)))} step="1" />
            </div>
            <div class="input-wrapper">
                <label>APR:</label>
                <div className="slider-container">
                    <span id="apr-value" className="slider-value">{apr}%</span>
                    <input type="range" id="apr" min="0" max="36" value={apr} onChange={(e) => setApr(e.target.value)} />
                </div>
            </div>
            <div className="input-wrapper">
                <label>Loan Term:</label>
                <div className="slider-container">
                    <span id="loan-term-value" className="slider-value">{loanTerm}  months</span>
                    <input type="range" id="loan-term" min="6" max="240" value={loanTerm} onChange={(e) => setLoanTerm(e.target.value)} />
                    <span className="slider-label"></span>
                </div>
            </div>
            <div className="input-wrapper">
                <label>Estimated Monthly Payment:</label>
                <span id="monthly-payment">{monthlyPayment !== noInput ? '$' + monthlyPayment : '' + monthlyPayment}</span>
            </div>
        </div>
    )
}

export default LoanCalculator;
